import axios from "config/axios";
import { GenericPageResponse, AuditLog } from "shared/types";

export const getAuditLog = (page: number, size: number, filters: string) =>
  axios.get<GenericPageResponse<AuditLog>>(
    `/audit-log?page=${page}&size=${size}&search=${filters}`,
  );
